export class SetEx<T> extends Set<T> {
  // create a new SetEx populated with the contents of one or more iterables
  constructor(...iterables: Iterable<T>[]) {
    super();
    this.merge(...iterables);
  }

  // merge the items from one or more iterables into this set
  merge(...iterables: Iterable<T>[]) {
    for (const iterable of iterables) {
      for (const item of iterable) {
        this.add(item);
      }
    }
    return this;
  }

  // return new SetEx object that is union of all sets passed in with the current set
  union = (...sets: Set<T>[]) => {
    const newSet = new SetEx(...sets);
    newSet.merge(this);
    return newSet;
  };

  // return a new SetEx that contains the items that are in both sets
  intersect(target: Set<T>) {
    const newSet = new SetEx();
    for (const item of this) {
      if (target.has(item)) {
        newSet.add(item);
      }
    }
    return newSet;
  }

  // return a new SetEx that contains the items that are in this set, but not in target
  // target must be a Set (or something that supports .has(item) such as a Map)
  diff(target: Set<T>) {
    const newSet = new SetEx();
    for (const item of this) {
      if (!target.has(item)) {
        newSet.add(item);
      }
    }
    return newSet;
  }

  // target can be either a Set or an Array
  // return boolean which indicates if target set contains exactly same elements as this
  // target elements are iterated and checked for this.has(item)
  sameItems(target: Set<T> | T[]) {
    let tsize;
    if ("size" in target) {
      tsize = target.size;
    } else if ("length" in target) {
      tsize = target.length;
    } else {
      throw new TypeError(
        "target must be an iterable like a Set with .size or .length",
      );
    }
    if (tsize !== this.size) {
      return false;
    }
    for (const item of target) {
      if (!this.has(item)) {
        return false;
      }
    }
    return true;
  }
}
